var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTransportation = function SvgTransportation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transportation_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#transportation_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.082 15.308V7.9h8.092v7.408H10.89a1.785 1.785 0 0 0-1.763-1.514c-.891 0-1.632.658-1.761 1.514H5.082Zm8.63-6.488 1.959.014h.001l3.247 3.106v3.367h-.812a1.785 1.785 0 0 0-1.765-1.533c-.9 0-1.644.668-1.766 1.533h-.865V8.82Zm1.08 1.088v2.494h3.046l-2.604-2.49-.443-.004Zm2.768 5.4a1.245 1.245 0 0 0-2.436 0 1.232 1.232 0 0 0-.026.25v.02a1.245 1.245 0 0 0 1.243 1.223 1.245 1.245 0 0 0 1.244-1.223v-.02c0-.085-.009-.168-.025-.25Zm-.731.26a.494.494 0 0 1-.487.478.491.491 0 0 1-.488-.478v-.01a.487.487 0 0 1 .974 0v.01Zm-7.704-1.233a1.246 1.246 0 0 1 1.213 1.515 1.243 1.243 0 1 1-1.213-1.514Zm0 1.73c.225 0 .426-.161.475-.382v.001a.508.508 0 0 0 .001-.21.491.491 0 0 0-.476-.382.49.49 0 0 0-.474.592c.049.22.248.38.474.38Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "transportation_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgTransportation as ReactComponent };